import { ScreenReaderOnly, TextBody } from '@ally/metronome-ui';
import React from 'react';
export const DashDash = ({ assistiveText }) => {
    return (React.createElement(TextBody, { tag: "span", size: "md" },
        React.createElement("span", { "aria-hidden": "true" }, "--"),
        React.createElement(ScreenReaderOnly, null, assistiveText)));
};
//# sourceMappingURL=DashDash.js.map